export const debounce = (func, delay) => {
  let timer
  return function (...args) {
    clearTimeout(timer)
    timer = setTimeout(() => func(...args), delay)
  }
}

// utils.js
export function replaceUnderscoresWithSpaces(text) {
  return text?.replace(/_/g, "")
}

export function blogSplitHTMLContent(htmlString) {
  if (typeof document !== "undefined") {
    // Create a temporary element to parse the HTML string
    const tempElement = document.createElement("div")
    tempElement.innerHTML = htmlString

    // Find the div with id 'ez-toc-container'
    const tocContainer = tempElement.querySelector("#ez-toc-container")

    if (tocContainer) {
      // Extract the content inside 'ez-toc-container'
      const table_of_content = tocContainer.outerHTML

      // Remove 'ez-toc-container' from the temporary element
      tocContainer.parentNode.removeChild(tocContainer)

      // Extract the remaining content as 'content'
      const content = tempElement.innerHTML

      // Clean up the temporary element
      tempElement.innerHTML = ""

      // Return the table_of_content and content
      return { table_of_content, content }
    } else return { table_of_content: "", content: "" }
  }
  // If 'ez-toc-container' is not found, return null
  else return { table_of_content: "", content: "" }
}

export const getFaqSchema = (data, faqShowSection) => {
  let faqSchema = {}
  if (faqShowSection === "yes") {
    const FAQ = data?.map(faq => {
      return {
        "@type": "Question",
        name: faq.faqListQuestion,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.faqListAnswer,
        },
      }
    })
    faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQ,
    }
  }

  return faqSchema
}

export const appNavigate = url => window.open(url, "_self")

export function scrollToElementById(id) {
  const element = document.getElementById(id)
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}

// Remove trailing slash
export const removeTrailingSlash = url => url?.replace(/\/{2,}/g, "/").replace(/\/+$/, "")
